var kind = require("enyo/kind");

require("enyo-ui");

/**
 * [VirtualizedRepeaterDrawAheadSupport]{@link enyo-ui.VirtualizedRepeaterDrawAheadSupport}
 * overrides [Repeater.getDrawBounds]{@link enyo-ui.Repeater#getDrawBounds} such
 * that it can expand beyond the bounds beyond the visible bounds of the
 * arrangement.
 *
 * @mixin  enyo-ui.VirtualizedRepeaterDrawAheadSupport
 * @public
 */
module.exports = {

    /**
     * @private
     */
    name: "enyo-ui.VirtualizedRepeaterDrawAheadSupport",

    /**
     * Define a minimum width for the draw bounds.
     *
     * @name      drawAheadMinWidth
     * @type      {number}
     * @default   0
     * @memberof  enyo-ui.VirtualizedRepeaterDrawAheadSupport
     * @public
     */

    /**
     * Define a minimum height for the draw bounds.
     *
     * @name      drawAheadMinHeight
     * @type      {number}
     * @default   0
     * @memberof  enyo-ui.VirtualizedRepeaterDrawAheadSupport
     * @public
     */

    /**
     * How many pages of repeater items to draw beyond the arrangement bounds on
     * the horizontal axis.
     *
     * @name      drawAheadPagesX
     * @type      {number}
     * @default   1
     * @memberof  enyo-ui.VirtualizedRepeaterDrawAheadSupport
     * @public
     */

    /**
     * How many pages of repeater items to draw beyond the arrangement bounds on
     * the vertical axis.
     *
     * @name      drawAheadPagesY
     * @type      {number}
     * @default   1
     * @memberof  enyo-ui.VirtualizedRepeaterDrawAheadSupport
     * @public
     */

    /**
     * @memberof  enyo-ui.VirtualizedRepeaterDrawAheadSupport
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);

            if (this.drawAheadMinWidth === undefined) {
                this.drawAheadMinWidth = 0;
            }

            if (this.drawAheadMinHeight === undefined) {
                this.drawAheadMinHeight = 0;
            }

            if (this.drawAheadPagesX === undefined) {
                this.drawAheadPagesX = 1;
            }

            if (this.drawAheadPagesY === undefined) {
                this.drawAheadPagesY = 1;
            }
        };
    }),

    /**
     * Extends the arrangementBounds by a set amount of 'pages' behind or ahead
     * of the current scroll position. A `page` in this is equal to the
     * dimensions of the scroller.
     *
     * @returns   {Object}  The bounds
     * @memberof  enyo-ui.VirtualizedRepeaterDrawAheadSupport
     * @method
     * @public
     */
    getDrawBounds: function() {
        var scroller = this.getScroller(),
            bounds   = this.getArrangementBounds();

        // For vertical scrollers, expand the bounds vertically.
        if (scroller.get("vertical")) {
            bounds.bottom = bounds.top + Math.max(
                this.drawAheadMinHeight,
                (this.drawAheadPagesY + 1) * (bounds.bottom - bounds.top)
            );
        }

        // For horizontal scrollers, expand the bounds horizontally.
        if (scroller.get("horizontal")) {
            bounds.right = bounds.left + Math.max(
                this.drawAheadMinWidth,
                (this.drawAheadPagesX + 1) * (bounds.right - bounds.left)
            );
        }

        return bounds;
    }

};
